module.exports = __webpack_public_path__ + "img/panda_half.7d4736b3.svg";